import { SafePromise, SafeType } from '@benzinga/safe-await';
import { Holding } from './entities';

export interface HoldingsIngress {
  'Holding Of': string;
  holdingName: string;
  holdingSymbols: string[];
}

export const ingestHoldings = async (holdingsData: SafePromise<HoldingsIngress[]>): SafePromise<Holding[]> => {
  const rawHoldings = await holdingsData;
  if (rawHoldings.err) {
    return rawHoldings as SafeType<Holding[]>;
  } else {
    return {
      ok: rawHoldings.ok.map(holding => {
        return {
          holdingName: holding['Holding Of'],
          holdingSymbols: holding.holdingSymbols,
        };
      }),
    };
  }
};
